// extracted by mini-css-extract-plugin
export default {"Root":"Search_Root__Fi14S","Input":"Search_Input__Wcr82","ClearIcon":"Search_ClearIcon__7LhV4"};